<template>
  <div style="text-align: center">
    <!-- <div id="qrcode" style="display: inline-block; margin-top: 100px"></div>
    <div
      style="font-size: 16px; color: black; margin-top: 50px; font-weight: 700"
    >
      打开小程序，个人中心-扫码登录
    </div> -->
    <div class="login flex-row" style="width:500px;">
      <div class="input-wrap" style="display:flex;align-items:center">
        <div style="font-size:22px;font-weight:900">账号: </div>
        <el-input type="text" v-model="name" placeholder="请输入账号" style="width:300px;margin-left:30px;font-weight:900" />
        <span v-if="error.name" class="err-msg">{{ error.name }}</span>
      </div>
      <div class="input-wrap" style="display:flex;align-items:center;margin-top:50px">
         <div style="font-size:22px;font-weight:900">密码: </div>
        
        <el-input type="password" v-model="pwd" placeholder="请输入密码" style="width:300px;margin-left:30px;"/>
        <span v-if="error.pwd" class="err-msg">{{ error.pwd }}</span>
      </div>

        <el-button type="primary" v-on:click="login" style="margin-top:100px;">提交</el-button>


      
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import QRCode from "qrcodejs2";
import AV from "leancloud-storage";
import LoginSessionToken from "../../model/loginSessionToken";
import Token from "../../model/token";

export default {
  data() {
    // return {
    //   url: "",
    // };
    return {
      name: "",
      pwd: "",
      error: {
        name: "",
        pwd: "",
      },
    };
  },

  created() {
    // this.getData();
  },
  methods: {
    getData() {
      console.log(111111111111);
      let loginSessionToken = new LoginSessionToken();
      loginSessionToken.token = "login";
      loginSessionToken
        .save()
        .then((session) => {
          console.log("session", session);
          let qrcode = new QRCode("qrcode", {
            width: 200,
            height: 200,
            text: loginSessionToken.id, // 二维码地址
            colorDark: "#000",
            colorLight: "#fff",
          });

          //监测
          var self = this;

          let aa = setInterval(function () {
            session.fetch().then((ss) => {
              console.log("登录成功", ss);

              if (ss.sessionToken.length > 0) {
                //登录成功
                console.log(ss);
                AV.User.become(ss.sessionToken)
                  .then(function (user) {
                    console.log(user);

                    if (
                      user.get("role") == "1999" ||
                      user.get("role") == "1998"
                    ) {
                      clearInterval(aa);

                      let license = user.get("username").split("-")[0];

                      //存储
                      localStorage.setItem("license", license);

                      new AV.Query(Token)
                        .equalTo("license", license)
                        .first()
                        .then((token) => {
                          localStorage.setItem("intro", token.intro);
                          self.$router.push({
                            path: "/",
                          });
                        });
                    } else {
                      this.$message.error("非管理员不能登录");
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            });
          }, 2000);
        })
        .catch((err) => {
          console.log("登录失败", err);
        });
    },
    check(name, pwd) {
      if (!name) {
        this.error.name = "请输入姓名";
        return false;
      }
      if (!pwd) {
        this.error.pwd = "请输入密码";
        return false;
      }
    },
    login() {
      console.log("当前登录信息", this);
      const { name, pwd, $router } = this;
      console.log("name", name);
      console.log("pwd", pwd);
 
      AV.User.logIn(name, pwd).then(
        (user) => {
          // 登录成功
          alert("登录成功", user);
          this.$router.push("/");
        
        },
        (error) => {
          // 登录失败（可能是密码错误）
          console.log("登录失败", error);
          alert("登录失败");
        }
      );

    },
  },
};
</script>

<style scoped lang="scss">
.login {
  width: 300px;
  margin: 10% auto;
}
</style>